import { render, staticRenderFns } from "./IngresoClinica.vue?vue&type=template&id=071239de&scoped=true"
import script from "./IngresoClinica.vue?vue&type=script&lang=js"
export * from "./IngresoClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071239de",
  null
  
)

export default component.exports